import { createEventDefs } from "../event-def";

// allows for nested objects with circular types
type NetworkAnalyticsDataValue = string | number | boolean | NestedObject;
type NestedObject = {
  [x: string]: NetworkAnalyticsDataValue;
};

export type NetworkAnalyticsDataRecord = Record<string, NetworkAnalyticsDataValue>;

export const NetworkingEvents = createEventDefs<{
  request_stats: {
    host: string;
    status: "success" | "fail" | "cancel";

    path: string;
    method: string;
    status_code?: number;
    latency?: number;

    error_kind?: "known" | "unknown";
    known_error_message?: string;
    known_error_code?: string;

    request_params?: NetworkAnalyticsDataRecord;
    response_data?: NetworkAnalyticsDataRecord;
  };
}>({
  namespacePrefix: "studio_network_",
});
